import { AddressSchema } from "@redotech/redo-model/order-schema";
import { WeightSchema } from "@redotech/redo-model/outbound-labels/util";
import * as z from "zod/v4";
import { PurchaseLabelType, RateSchema } from "./purchase-label";

export const getLabelRates = {
  name: "getLabelRates" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    fromAddress: AddressSchema,
    toAddress: AddressSchema,
    weight: WeightSchema,
    originalShipmentId: z.string().optional(),
    labelType: z.nativeEnum(PurchaseLabelType),
  }),
  output: z.object({
    rates: z.array(RateSchema),
    originalLabelCost: z.number(),
  }),
};
